import { useRecoilValue } from "recoil";
import { authState } from "../features/recoil";

export const useAuth = () => {
    const auth = useRecoilValue(authState);
    const { isSignedIn, userInfo } = auth;

    const get = (key: string): any => {
        return userInfo[key];
    };

    return { isSignedIn, get };
};
